import Modal from './modal.js';

var ConfirmationStringModal = Modal.extend({
  callbacks: [],
  template: 'components/confirmation_string_modal',
  events: {
    'click .confirm': '_proceed',
    'click .cancel': '_doNotProceed',
    'keyup #confirm-field': '_shouldEnable',
    'paste #confirm-field': '_preventPaste',
  },

  initialize: function (options) {
    this.extendableInitialize(options);
    this.callbacks = [];
  },

  answer: function (callback) {
    this.callbacks.push(callback);
    this._setupRender();
  },

  _triggerCallbacks: function (value) {
    this.callbacks.forEach(function (c) {
      c(value);
    });
  },

  _formatModal: function () {
    var onePercent = $(window).width() / 100,
      width = 30;

    return {
      top: $(document).scrollTop() + $(window).height() / 4,
      left: ($(window).width() - 640) / 2,
      width: 620,
      height: onePercent * width,
    };
  },

  _afterClose: function () {
    console.log('afer close');
  },

  _setupRender: function () {
    var style;

    style = this._formatModal();

    this.wait = false;
    this.show({
      top: style.top,
      left: style.left,
    });

    var renderData = {
      width: style.width,
      height: style.height,
      confirm_string: this.opts.confirm_string,
    };

    this.setContent(this.render_template(renderData, this.template));
  },

  _preventPaste: function (e) {
    e.preventDefault();
  },

  _shouldEnable: function (e) {
    if (e.target.value == this.opts.confirm_string) {
      this.$('.confirm').removeClass('disabled');
    } else {
      this.$('.confirm').addClass('disabled');
    }
  },

  _proceed: function () {
    this._triggerCallbacks(true);
  },

  _doNotProceed: function () {
    this._triggerCallbacks(false);
  },
});

module.exports = ConfirmationStringModal;
